import { useEffect } from 'react';
import useGetChatSessions from '../hooks/useGetChatSessions';
import { hasUnreadMessages } from '../utils/unreadDetection';

interface Props {
  sessionId: string;
}

export const UnreadMessagesCounter = ({ sessionId }: Props) => {
  const { data: sessions, refetch, isFetching } = useGetChatSessions();
  
  useEffect(() => {
    refetch();
  }, [refetch]);
  
  const currentSession = sessions?.find((session) => session.id === sessionId);
  
  // Use the same logic as the main unread detection
  const isUnread = currentSession ? hasUnreadMessages(currentSession) : false;
  
  if (!isUnread || isFetching) {
    return null;
  }
  
  // For now, show a red dot with "1" since we can't get exact count without fetching messages
  // In a real implementation, you might want to add an unread_count field to the ChatSession type
  return (
    <div className='text-white bg-holifya-red rounded-full w-4 h-4 flex items-center justify-center p-3 font-bold text-[12px]'>
      1
    </div>
  );
};
